import styled from "styled-components";

const Button = styled.button`
  min-height: 40px;
  font-size: 16px;
  padding: 0 30px 0 20px;
  border: solid 1px #ccc;
  background-color: #fff;
  border-radius: 3px;

  cursor: pointer;
  &:hover {
    border-color: #b3b2b2;
    background-color: #f2f2f2;
  }
`;
export default Button;
